<div class="app-wrapper" [attr.isAuthPage]="isAuthPage">
  <router-outlet></router-outlet>
  <div class="versions-wrapper">
    <p *ngIf="isAuthPage && !isWelcomePage" class="version-text">{{showBothVersions ? 'UI - ' + 'V' + version : 'V' + version}}</p>
    <p *ngIf="isAuthPage && !isWelcomePage && showBothVersions" class="version-text">{{'API - ' + 'V' + versionFromBack}}</p>
  </div>
</div>
<app-notification></app-notification>
